export function downloadFile(data, filename, dataURI = true) {
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = data;
  if (dataURI) {
    tempLink.setAttribute('download', filename);
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
  } else {
    tempLink.setAttribute('target', '_blank');
  }
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
}
